<template>
  <div class="Grid"
    :style="styles">

    <slot />

  </div>
</template>

<script>
/**
 * Grid
 * - A consistant global grid component.
 */
export default {
  name: 'Grid',

  props: {
    columns: {
      type: Number,
      default: 12
    },
    columnGap: {
      type: String,
      default: '24px'
    },
    rowGap: {
      type: String,
      default: '24px'
    }
  },

  computed: {
    /**
     * Styles for the main element
     * @return {Object}
     */
    styles () {
      return {
        'grid-template-columns': `repeat(${this.columns}, 1fr)`,
        'grid-column-gap': this.columnGap,
        'grid-row-gap': this.rowGap
      }
    }
  }
}
</script>

<style>
@import 'properties';

.Grid {
  /* IE 11 fixes */
  margin: 0 -12px;
  clear: both;

  @supports (display: grid) {
    margin: auto;
    display: grid;
  }
}

/**
 * IE 11
 */
.Grid > * {
  padding: 12px;

  @supports (display: grid) {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// Grid.vue?55620159